import { TypedDocumentNode, gql } from "@apollo/client";

interface MediaData {
  medias: MediaInterface[];
}

export const GET_MEDIAS: TypedDocumentNode<MediaData> = gql`
  query GetMedias {
    medias {
      media_url
      reading_time
      logo
      description
      publish_at
      headline
      media_house_name
      is_trending
      views
      thumbnail
      media_logo
      thumbnail_logo
    }
  }
`;
